import React, {Component} from 'react';
import { TextField, List, ListItem, ListItemText, FormHelperText, TableRow } from "@mui/material";
import firebase from "./../firebase";
//import $ from 'jquery'; './jquery.dataTables.min.css';
import ReactJWPlayer from 'react-jw-player';
// eslint-disable-next-line import/no-webpack-loader-syntax
//import Captions from "file-loader!../assets/sub/Avatar_2009_sub_ro.vtt";
import $, { data } from 'jquery';
import moment from 'moment';
import Select from 'react-select';
//import 'react-select-2/dist/css/react-select-2.css';
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push,remove } from "firebase/database";

//const $ = require('jquery');
$.DataTable = require('datatables.net');
const axios = require('axios');

export default class Bodycontentyoutubefree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: [],
            role: '',
            count:0,
            count_logs: 0,
            myip: '',
            mylocation: '',
            channels: [],
            all_channels: [],
            datatable: [],
            addsopcast: 'sop://broker.sopcast.com:3912/6002',
            addtitlesopcast: 'CCV5',
            playlist: 'PLEdxk7snhbAxq5xXKPPOKUPZTDHqP0jlN',
            videoTitle: '',
            avatar_sub:false,
            avatar_movie:true, //end movies
            autostart:true,
            jwplayer:false,
            videoplayer:false,
            videoadultplayer:false,
            youtubeplaylist:'https://www.youtube.com/embed/videoseries?list=PLEdxk7snhbAziypuUb1v0Z0syhW28DwUm',
            youtubeplaylistadd:false,
            youtubeplaycount:0,
            youtubeplayID: '',
            youtubeplaylistTitle:'',
            youtubeplaylistarr:[],
            youtubeplaylistedit:false,
            jwtcategory:[
              {
                'id': 1,
                'title': 'TV Channels',
                'description': 'Description of TV Channels'
              },
              {
                'id': 2,
                'title': 'Adult TV Channels',
                'description': 'Description of Adult TV Channels'
              },
              {
                'id': 3,
                'title': 'Movies Channels',
                'description': 'Description of Movies Channels'
              },
              {
                'id': 4,
                'title': 'Adult Movie Channels',
                'description': 'Description of Adult Movie Channels'
              },
            ],
            jwtsubcategory:[
              {
                'id': 1,
                'title': 'SF',
                'description': 'Science Fiction'
              },
              {
                'id': 2,
                'title': 'Love',
                'description': 'Love'
              },
              {
                'id': 3,
                'title': 'Documentary',
                'description': 'Documentary'
              },
              {
                'id': 4,
                'title': 'Childs',
                'description': 'Childs'
              },
            ],
            countjwtcategory:0,
            countjwtsubcategory:0,
            jwtcategories:0,
            jwtsubcategories:'',
            selectoptions:[],
            rezumat:'Canal TV Stiri',
            denumireselectie:'',
            carouselitems:[],
            width: 0, 
            height: 0,
            radiocheckedone: true,
            radiocheckedtwo: false,
            radioselect: '',
            currentPage: 1,
            itemsPerPage: 5,
            upperPageBound: 3,
            lowerPageBound: 0,
            isPrevBtnActive: 'disabled',
            isNextBtnActive: '',
            pageBound: 3,
            mylistcheck: true
        };
    
        this.onAdPlay = this.onAdPlay.bind(this);
        this.onReady = this.onReady.bind(this);
        this.onVideoLoad = this.onVideoLoad.bind(this);
    
        // each instance of <ReactJWPlayer> needs a unique id.
        // we randomly generate it here and assign to the container instance.
        this.playerId = '123456';
        var Select = require('react-select');

        this.handleClick = this.handleClick.bind(this);
        this.btnDecrementClick = this.btnDecrementClick.bind(this);
        this.btnIncrementClick = this.btnIncrementClick.bind(this);
        this.btnNextClick = this.btnNextClick.bind(this);
        this.btnPrevClick = this.btnPrevClick.bind(this);
        // this.componentDidMount = this.componentDidMount.bind(this);
        this.setPrevAndNextBtnClass = this.setPrevAndNextBtnClass.bind(this);
    }

    onReady(event) {
      // interact with JW Player API here
      const player = window.jwplayer(this.playerId);
    }
    onAdPlay(event) {
      // track the ad play here
    }
    onVideoLoad(event) {
      this.setState({
        videoTitle: event.item.description // this only works with json feeds!
      });
    }

    updateWindowDimensions() {
      this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    handleClick(event) {
      let listid = Number(event.target.id);
      this.setState({
        currentPage: listid
      });
      $("ul li.active").removeClass('active');
      $('ul li#'+listid).addClass('active');
      this.setPrevAndNextBtnClass(listid);
    }
    setPrevAndNextBtnClass(listid) {
      let totalPage = Math.ceil(this.state.carouselitems.length / this.state.itemsPerPage);
      this.setState({isNextBtnActive: 'disabled'});
      this.setState({isPrevBtnActive: 'disabled'});
      if(totalPage === listid && totalPage > 1){
          this.setState({isPrevBtnActive: ''});
      }
      else if(listid === 1 && totalPage > 1){
          this.setState({isNextBtnActive: ''});
      }
      else if(totalPage > 1){
          this.setState({isNextBtnActive: ''});
          this.setState({isPrevBtnActive: ''});
      }
  }
    btnIncrementClick() {
        this.setState({upperPageBound: this.state.upperPageBound + this.state.pageBound});
        this.setState({lowerPageBound: this.state.lowerPageBound + this.state.pageBound});
        let listid = this.state.upperPageBound + 1;
        this.setState({ currentPage: listid});
        this.setPrevAndNextBtnClass(listid);
  }
    btnDecrementClick() {
      this.setState({upperPageBound: this.state.upperPageBound - this.state.pageBound});
      this.setState({lowerPageBound: this.state.lowerPageBound - this.state.pageBound});
      let listid = this.state.upperPageBound - this.state.pageBound;
      this.setState({ currentPage: listid});
      this.setPrevAndNextBtnClass(listid);
  }
  btnPrevClick() {
      if((this.state.currentPage -1)%this.state.pageBound === 0 ){
          this.setState({upperPageBound: this.state.upperPageBound - this.state.pageBound});
          this.setState({lowerPageBound: this.state.lowerPageBound - this.state.pageBound});
      }
      let listid = this.state.currentPage - 1;
      this.setState({ currentPage : listid});
      this.setPrevAndNextBtnClass(listid);
      //alert(this.state.currentPage);
      //$('ul.pagination li.active').removeClass('active');
      $('ul.pagination li#'+(this.state.currentPage-1)+' button#'+(this.state.currentPage-1)).addClass('active');
  }
  btnNextClick() {
      if((this.state.currentPage +1) > this.state.upperPageBound ){
          this.setState({upperPageBound: this.state.upperPageBound + this.state.pageBound});
          this.setState({lowerPageBound: this.state.lowerPageBound + this.state.pageBound});
      }
      let listid = this.state.currentPage + 1;
      this.setState({ currentPage : listid});
      this.setPrevAndNextBtnClass(listid);
      //alert(this.state.currentPage);
      //$('ul.pagination li.active').removeClass('active');
      $('ul.pagination li#'+(this.state.currentPage+1)+' button#'+(this.state.currentPage+1)).addClass('active');
  }

    componentDidMount() {
      //alert(localStorage.getItem('user_id'))
      window.addEventListener("resize", this.updateWindowDimensions());
      $('ul.pagination li.active').removeClass('active');
      $('ul.pagination li#'+this.state.currentPage+' button#'+this.state.currentPage).addClass('active');
      this.getUser()
      this.logs()
      //alert(btoa('meserie:test20200801'))
      /*const auth = 'Basic '+btoa('meserie:test20200801');
      fetch('https://diskoteka.ro/apitickets/channelstv/all',{
        //mode: 'no-cors',
        method: 'GET',
        headers: new Headers({
          'Accept': auth, 
          'Content-Type': 'text/plain'
        })})
        .then(blob => blob.json())
        .then((data)=> {
          //alert(JSON.stringify(data))
          //var data = res.json()
          //console.log(JSON.stringify(data))
          //const data=1;
          if(data.length>1){
            //console.log(JSON.stringify(data))
            this.setState({ channels: data })
            var select_options = []
            firebase.database().ref("/channelstv_jwt").remove()
            data.forEach(child => {
            var refdb = firebase.database().ref('/channelstv_jwt').push();
            refdb = refdb.toString().slice(-20);
            let updateData = firebase.database().ref("/channelstv_jwt").child(refdb);
            updateData.child("id").set(child.id);
            updateData.child("denumire").set(child.denumire);
            updateData.child("adresa").set(child.adresa);
            updateData.child("adresatwo").set(child.adresatwo);
            updateData.child("category").set(child.category);
            updateData.child("description").set(child.description);
            updateData.child("subcategory").set(child.subcategory);
            updateData.child("image").set(child.image);
            updateData.child("year").set(child.year);
            updateData.child("status").set(child.status);
            select_options.push({
              value: child.id,
              label: child.denumire
            })
            })
            this.setState({ selectoptions: select_options })
          }else{
            //firebase.database().ref("/channelstv_jwt").on('value', snapshot => {
              const db = getDatabase();
              get(ref(db, 'channelstv_jwt')).then((snapshot)=>{
              var channelstv_jwt = []
              var select_options = []
              snapshot.forEach(child => {
                var data = child.val()
                  channelstv_jwt.push({
                    id: data.id,
                    denumire: data.denumire,
                    adresa: data.adresa,
                    adresatwo: data.adresatwo,
                    category: data.category,
                    description: data.description,
                    subcategory: data.subcategory,
                    image: data.image,
                    year: data.year,
                    imdb: data.imdb,
                    status: data.status
                  })
                  select_options.push({
                    value: data.id,
                    label: data.denumire
                  })
              this.setState({ channels: channelstv_jwt, all_channels: channelstv_jwt, selectoptions: select_options })
            })
          })
          }
          //firebase.database().ref("/youtube_list").orderByChild('userid')
          //.equalTo(localStorage.getItem('user_id').substring(0, localStorage.getItem('user_id').length)).on('value', snapshot => {
          const db = getDatabase();
          get(query(ref(db, 'youtube_list'), orderByChild('userid'),equalTo(localStorage.getItem('user_id')))).then((snapshot)=>{
            var youtubeplaylistarr_tmp = [];
            var youtubecount_tmp = 0;
            snapshot.forEach(child => {
              var data = child.val();
              youtubecount_tmp = youtubecount_tmp+1;
              youtubeplaylistarr_tmp.push({
                id:data.id,
                youtubeplayID:"https://www.youtube.com/embed/videoseries?list="+data.youtubeplayID+"&html5=1",
                youtubeplayTitle:data.youtubeplayTitle,
                userid:data.userid,
                time:data.time
              })
              this.setState({youtubeplaylistarr:youtubeplaylistarr_tmp,youtubeplaycount:youtubecount_tmp})
            })
          })  

          this.setState({
            all_channels: this.state.channels
          });
          
        setTimeout(function(){ 
          if(this.state.role === '"adminc"'){
            //alert('Adminc');
            //alert(this.state.role);
            var channelstv_jwt = [] 
            this.state.channels.forEach(data => {
              if((parseInt(data.category) !== 2) && (parseInt(data.category) !== 4)){
              channelstv_jwt.push({
                id: data.id,
                denumire: data.denumire,
                adresa: data.adresa,
                adresatwo: data.adresatwo,
                category: data.category,
                description: data.description,
                subcategory: data.subcategory,
                image: data.image,
                year: data.year,
                imdb: data.imdb,
                status: data.status
              })
            }
          })
          this.setState({ channels: channelstv_jwt, all_channels: channelstv_jwt })
          
          var cat_channelstv_jwt = [] 
            this.state.jwtcategory.forEach(data => {
              //alert(data.category);
              if((parseInt(data.id) !== 2) && (parseInt(data.id) !== 4)){
              //  alert(data.category);
              cat_channelstv_jwt.push({
                id: data.id,
                title: data.title,
                description: data.description
              })
            }
          })
          this.setState({ jwtcategory: cat_channelstv_jwt })

          var subcat_channelstv_jwt = [] 
            this.state.jwtsubcategory.forEach(data => {
              //alert(data.category);
              //  alert(data.category);
              subcat_channelstv_jwt.push({
                id: data.id,
                title: data.title,
                description: data.description
              })
          })
          this.setState({ jwtsubcategory: subcat_channelstv_jwt })
          }
          //firebase.database().ref("/youtube_list").orderByChild('userid')
          //.equalTo(localStorage.getItem('user_id').substring(0, localStorage.getItem('user_id').length)).on('value', snapshot => {
          const db = getDatabase();
          get(query(ref(db, 'youtube_list'), orderByChild('userid'),equalTo(localStorage.getItem('user_id')))).then((snapshot)=>{
              var youtubeplaylistarr_tmp = [];
              snapshot.forEach(child => {
                var data = child.val();
                youtubeplaylistarr_tmp.push({
                  id:data.id,
                  youtubeplayID:"https://www.youtube.com/embed/videoseries?list="+data.youtubeplayID+"&html5=1",
                  youtubeplayTitle:data.youtubeplayTitle,
                  userid:data.userid,
                  time:data.time
                });
                //setTimeout(function(){ 
                this.setState({youtubeplaylistarr:youtubeplaylistarr_tmp});
                //}.bind(this), 200);
              })
            }); 
        }.bind(this), 100);
      });*/
      
    }

    //componentWillUnmount(){
    //  this.$el.DataTable.destroy(true);
    //}

    logs = () => {
      //alert('Did Logs');
      const db = getDatabase();
      //firebase.database().ref("/logs").on('value', snapshot => {
        get(ref(db, 'logs')).then((snapshot)=>{
        var select_logs = []
        snapshot.forEach(child => {
          var data = child.val()
          select_logs.push({
              id: data.id,
              status: data.status,
              message: data.message,
              agent: data.agent,
              ip: data.ip,
              location: data.location,
              user_id: data.user_id,
              time: data.time,
            })
        this.setState({ count_logs: select_logs.length })
        
        })
      })
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((data) => {
          //alert(JSON.stringify(data.ip))
            setTimeout(function(){ 
              this.setState({ myip: data.ip, mylocation: data.country_name+'#'+data.region })
            }.bind(this), 200);
  
      setTimeout(function(){ 
      //alert(JSON.stringify(this.state.count_logs));
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      /*var refdb = firebase.database().ref('/logs').push();
      refdb = refdb.toString().slice(-20);
      
      let updateData = firebase.database().ref("/logs").child(refdb);
      updateData.child("id").set(this.state.count_logs+1);
      updateData.child("status").set('1');
      updateData.child("message").set('User Access Youtube Free Page');
      updateData.child("agent").set(navigator.userAgent);
      updateData.child("ip").set(this.state.myip);
      updateData.child("location").set(this.state.mylocation);
      updateData.child("user_id").set(localStorage.getItem('user_id'));
      updateData.child("time").set(curtime);*/
      var refdb = push(ref(db,'/logs'));
      //refdb_ref = refdb.toString().slice(-20);
      
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((dataipres) => {
          //let updateData = ref(db,"logs/"+refdb);
          set(refdb,{
            id:this.state.count_logs+1,
            status:'1',
            message:'User Access Youtube FREE Page',
            agent:String(navigator.userAgent),
            ip: String(dataipres.ip),
            location:String(dataipres.country_name+'#'+dataipres.region),
            user_id:String(localStorage.getItem('user_id')),
            time:String(curtime)
          });
      });
      }.bind(this), 400);
    })

    }

    getUser = () => {
      const db = getDatabase();
      /*firebase.database().ref("/users").orderByChild('email')
      .equalTo(localStorage.getItem('user_id')).on('value', snapshot => {*/
      get(query(ref(db, 'users'), orderByChild('email'),equalTo(localStorage.getItem('user_id')))).then((snapshot)=>{
        var userg = []
        snapshot.forEach(child => {
          var data = child.val()
        userg.push({
          id: data.key, 
          email: data.email,
          name: data.name,
          nickname: data.nickname,
          phone: data.phone,
          role: data.role,
          time: data.time
        })
        this.setState({ user: userg })
      })
        
      })
      setTimeout(function(){ 
        this.setState({ role: JSON.stringify(this.state.user[0].role) })
        //alert(JSON.stringify(this.state.role))
      //alert(JSON.stringify(this.state.user[0].role))   
      }.bind(this), 300);   
    }


    setSelectedOption = (val) =>{
      //alert(JSON.stringify(val));
      this.setState({
        youtubeplaylist: val
      });
    }
    
    setSelectedOptionMan = (val) =>{
      //alert(JSON.stringify(val));
      this.setState({
        youtubeplaylist: 'https://www.youtube.com/embed/videoseries?list='+val+'&html5=1',
        youtubeplayID:val,
        youtubeplaylistadd:true
      });
    }

    youtubeplaylistadd = (val) =>{
      //alert(JSON.stringify(val));
      setTimeout(function(){ 
        //alert(JSON.stringify(this.state.count_logs));
        var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
        /*var refdb = firebase.database().ref('/youtube_list').push();
        refdb = refdb.toString().slice(-20);
        
        let updateData = firebase.database().ref("/youtube_list").child(refdb);
        updateData.child("id").set(this.state.youtubeplaycount+1);
        updateData.child("youtubeplayID").set(this.state.youtubeplayID);
        updateData.child("youtubeplayTitle").set(this.state.youtubeplaylistTitle);
        updateData.child("userid").set(localStorage.getItem('user_id'));
        updateData.child("time").set(curtime);*/
        const db = getDatabase();
        var refdb = push(ref(db,'youtube_list'));
        set(refdb,{
          id:this.state.youtubeplaycount+1,
          youtubeplayID:this.state.youtubeplayID,
          youtubeplayTitle:this.state.youtubeplaylistTitle,
          userid:String(localStorage.getItem('user_id')),
          time:String(curtime)
        });
        }.bind(this), 100);
    }

    setPlaylistTitle = (val) =>{
      this.setState({
        youtubeplaylistTitle: val
      });
    }

    mylistChange = (val) =>{
      this.setState({
        mylistcheck: val
      });
      //alert(JSON.stringify(this.state.mylistcheck));
      this.getMyList();
    }

    getMyList(){
      //alert(JSON.stringify(this.state.mylistcheck));
      //alert(JSON.stringify(localStorage.getItem('user_id').substring(0, localStorage.getItem('user_id').length)));
      //setTimeout(function(){
      this.setState({youtubeplaylistarr:[]});
      if(this.state.mylistcheck===false){
        /*firebase.database().ref("/youtube_list").orderByChild('userid')
      .equalTo(localStorage.getItem('user_id').substring(0, localStorage.getItem('user_id').length)).on('value', snapshot => {*/
      const db = getDatabase();
      get(query(ref(db, 'youtube_list'), orderByChild('userid'),equalTo(localStorage.getItem('user_id')))).then((snapshot)=>{
          var youtubeplaylistarr_tmp = [];
          snapshot.forEach(child => {
            var data = child.val();
            youtubeplaylistarr_tmp.push({
              id:data.id,
              youtubeplayID:"https://www.youtube.com/embed/videoseries?list="+data.youtubeplayID+"&html5=1",
              youtubeplayTitle:data.youtubeplayTitle,
              userid:data.userid,
              time:data.time
            });
            //setTimeout(function(){ 
            this.setState({youtubeplaylistarr:youtubeplaylistarr_tmp});
            //}.bind(this), 200);
          })
        })  
      }else if(this.state.mylistcheck===true){
        //firebase.database().ref("/youtube_list").on('value', snapshot => {
          const db = getDatabase();
          get(ref(db, 'youtube_list')).then((snapshot)=>{
          var youtubeplaylistarr_tmp = [];
          snapshot.forEach(child => {
            var data = child.val();
            youtubeplaylistarr_tmp.push({
              id:data.id,
              youtubeplayID:"https://www.youtube.com/embed/videoseries?list="+data.youtubeplayID+"&html5=1",
              youtubeplayTitle:data.youtubeplayTitle,
              userid:data.userid,
              time:data.time
            });
            //setTimeout(function(){ 
            this.setState({youtubeplaylistarr:youtubeplaylistarr_tmp});
            //}.bind(this), 200);
          })
        })  
      }
     //}.bind(this), 300);
    }

    render(){
      const carouselindicatorsl={
        backgroundColor: 'red',
        width: '20px',
        margin: '0 0 0 -30px'
      }
      const carouselindicatorsr={
        backgroundColor: 'red',
        width: '20px',
        margin: '0 -30px 0 0'
      }
      const carouselindicatorslin={
        backgroundColor: 'red',
        width: '20px',
      }
      const carouselindicatorsrin={
        backgroundColor: 'red',
        width: '20px',
      }
      const carouseldivimg={
        display: 'inline-block',
        marginLeft: '-4px',
        cursor: 'pointer',
        minHeight: '200px',
        height: 'auto',
      }
      const carouselimg={
        width: '100%',
        height: 'auto',
        display: 'inline-block',
        marginLeft: '-4px'
      }
      const displaynone={
        display: 'none'
      }
      const { carouselitems, currentPage, itemsPerPage,upperPageBound,lowerPageBound,isPrevBtnActive,isNextBtnActive } = this.state;
      // Logic for displaying current todos
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      const currentItems = carouselitems.slice(indexOfFirstItem, indexOfLastItem);
      //console.log(currentItems);
      //currentItems.shift();
      //for (let i = 0; i < (parseInt(itemsPerPage)-2); i++) {
      //  currentItems.pop();
      //}
      //currentItems.shift();
      const renderItems = currentItems.map((item, index) => {
        return (parseInt(index)===0)?(<div className="container carousel-inner no-padding" style={nopadding} >
        {currentItems.map((channel, index) => (
        <div className={(index===0)?("carousel-item active"):("carousel-item")} key={index}>
          {channel.carouselitemssub.map((item, i) => (
              <div className="col-xs-3 col-sm-3 col-md-3" style={carouseldivimg}  onClick={(() => this.carouselselectchannel(item.adresa))} key={i}>
                <img style={carouselimg} src={item.image} title={item.denumire+' - '+item.description}></img>
                <p>Date: {item.year}</p>{(item.category==='3')?(<p>IMDB: {item.imdb}</p>):(<p></p>)}
              </div>
          ))}  
        </div>
        ))}
      </div>):'';
      });

      // Logic for displaying page numbers
      const pageNumbers = [];
      for (let i = 1; i <= Math.ceil(carouselitems.length / itemsPerPage); i++) {
        pageNumbers.push(i);
      }
      //console.log(Math.ceil(currentItems.length / itemsPerPage));
      const renderPageNumbers = pageNumbers.map(number => {
          if(number === 1 && currentPage === 1){
              return(
                  <li key={number} className='active' id={number}><button id={number} onClick={((e) => this.handleClick(e))} className={(this.state.currentPage===number)?("btn btn-primary active"):("btn btn-primary")}>{number}</button></li>
              )
          }
          else if((number < upperPageBound + 1) && number > lowerPageBound){
              return(
                  <li key={number} id={number}><button id={number} onClick={((e) => this.handleClick(e))} className={(this.state.currentPage===number)?("btn btn-primary active"):("btn btn-primary")}>{number}</button></li>
              )
          }
      });
      let pageIncrementBtn = null;
      if(pageNumbers.length > upperPageBound){
          pageIncrementBtn = <li className=''><button onClick={((e) => this.btnIncrementClick(e))} className="btn btn-primary"> &hellip; </button></li>
      }
      let pageDecrementBtn = null;
      if(lowerPageBound >= 1){
          pageDecrementBtn = <li className=''><button onClick={((e) => this.btnDecrementClick(e))} className="btn btn-primary"> &hellip; </button></li>
      }
      let renderPrevBtn = null;
      if(isPrevBtnActive === 'disabled') {
          renderPrevBtn = <li className={isPrevBtnActive}><span id="btnPrev" className="btn btn-warning disabled" > Prev </span></li>
      }
      else{
          renderPrevBtn = <li className={isPrevBtnActive}><button id="btnPrev" onClick={((e) => this.btnPrevClick(e))} className="btn btn-primary"> Prev </button></li>
      }
      let renderNextBtn = null;
      if(isNextBtnActive === 'disabled') {
          renderNextBtn = <li className={isNextBtnActive}><span id="btnNext" className="btn btn-warning disabled" > Next </span></li>
      }
      else{
          renderNextBtn = <li className={isNextBtnActive}><button id="btnNext" onClick={((e) => this.btnNextClick(e))} className="btn btn-primary"> Next </button></li>
      }
          const divStyless={  
            height:'150px',
            position:'relative',
            marginBottom: '350px'
          };
          const divStylesssp={
            position:'relative',
            marginBottom: '250px',
            diplay:'flex'
          };
          const videoplayerstyle={
            marginBottom: '20px',
            width: '590px'
          };
          const selecttwostyle={
            marginRight: '20px',
            width: '150px'
          }
          const canalestyle={
            top: '25%',
            transform: 'translateY(25%)',
            verticalAlign: 'center',
            padding: '0 0 0 20px',
          }
          const rezumatstyle={
            display: 'inline-block',
          }
          const lasthrstyle={
            display: 'inline-block',
            position: 'relative',
            padding: '100px 0 100px 0',
          }
          const nopadding={
            paddingLeft: '0',
            paddingRight: '0'
          }
         
          const divradiobutons={
            zIndex: '100'
          }

          const maninput={
            marginRight: '-35px'
          }

          const mylist={
            display: 'inline-group',
            marginTop: '10px',
            marginLeft: '5px'
          }

          const mylistlabel={
            display: 'inline-group',
            marginTop: '5px',
            marginLeft: '25px'
          }
        return (
            <main role="main" className="col-md-9 ml-sm-auto col-lg-10 pt-3 px-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
              <h1 className="h2">Dashboard  Free Youtube Page</h1>
            </div>
            <p>Dashboard Free Youtube Page</p>
          <div>
<div className="row col-9"> 
<label>Selectati lista:</label>
<select id="txUrlCateg" name="txUrlCateg" className="custom-select col-6 ml-auto" onChange={e => this.setSelectedOption(e.target.value)}>
    <option>Selectati youtube play list</option>
    {this.state.youtubeplaylistarr.map((data) => (
    <option value={data.youtubeplayID} key={data.youtubeplayID}>{data.youtubeplayTitle}</option>
    ))}
</select><br/>
<div className="row col-xs-4"> 
<label style={mylistlabel}>My Playlist</label>
<input
  type="checkbox"
  name="mylist"
  checked={this.state.mylistcheck}
  style={mylist}
  onChange={(e) => {
    this.mylistChange(e.target.checked);
  }}
/>
</div><br/>
<iframe width="750" height="500" src={this.state.youtubeplaylist} frameborder="0" allowfullscreen="allowfullscreen"
        mozallowfullscreen="mozallowfullscreen" 
        msallowfullscreen="msallowfullscreen" 
        oallowfullscreen="oallowfullscreen" 
        webkitallowfullscreen="webkitallowfullscreen"></iframe><br/>
<div className="row col-12">
<label htmlFor="inputman">Input Manual Playlist ID</label>
<input id="inputman" name="inputman" type="text" className="form-control col-8 ml-auto" style={maninput} value={this.state.playlist} onChange={e => this.setSelectedOptionMan(e.target.value)}></input>
</div>
{this.state.youtubeplaylistadd===true && (<div className="row col-12">
<label htmlFor="inputman">Playlist Title</label>
<input id="inputmantitle" name="inputmantitle" type="text" className="form-control col-8 ml-auto" style={maninput} onChange={e => this.setPlaylistTitle(e.target.value)}></input>
<div className = "row col-12">
<button  className = "btn btn-primary" onClick={(() => this.youtubeplaylistadd())}>Add</button>
{this.state.youtubeplaylistedit===true && (<button  className = "btn btn-primary" onClick={(() => this.EditPlaylist())}>Edit</button>)}
</div>
</div>)}
</div>
            </div>
            <hr style={lasthrstyle}/>
          </main>  
        )
    }
}